import React from 'react';
export const LayoutDetailsContext = React.createContext({});
